import { Form, FormItemProps } from "antd";

export function FormItem<T>(props: FormItemProps<T>) {
  return <Form.Item {...props} />;
}
